import {
  PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME,
  PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME,
  PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME,
  PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME,
  PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME,
  RESET_PII_PROFILE_PERSONAL_DETAILS,
} from 'features/pii/const';
import useCommonStore from 'hooks/useCommonStore';
import { isEmpty } from 'lodash';
import { SET_FORM_PROFILE_KYC_INFORMATION } from 'store/action';

const useProfileKYCStore = () => {
  const { state, setState, dispatch, setLoading } = useCommonStore();
  const { formProfileKYCInformation } = state || {};

  const setFormProfileKYCInformation = (
    payload = RESET_PII_PROFILE_PERSONAL_DETAILS
  ) => {
    setState({
      action: SET_FORM_PROFILE_KYC_INFORMATION,
      payload: {
        ...formProfileKYCInformation,
        ...(!isEmpty(payload) && payload),
      },
    });
  };

  const getFormProfileKYCPersonalDetails = () => ({
    ...formProfileKYCInformation,
    [PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME]:
      formProfileKYCInformation?.[PII_PROFILE_PERSONAL_DETAILS_FISTNAME_NAME],
    [PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME]:
      formProfileKYCInformation?.[PII_PROFILE_PERSONAL_DETAILS_LASTNAME_NAME],
    [PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME]:
      formProfileKYCInformation?.[PII_PROFILE_PERSONAL_DETAILS_OCCUPATION_NAME],
    [PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME]:
      formProfileKYCInformation?.[
        PII_PROFILE_PERSONAL_DETAILS_PREVIOUS_EMPLOYED_NAME
      ],
  });
  const getFormProfileKYCResidentialAddress = () => ({
    ...formProfileKYCInformation,
    [PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME]:
      formProfileKYCInformation?.[PII_PROFILE_RESIDENTIAL_ADDRESS_SWITCH_NAME],
    [PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME]:
      formProfileKYCInformation?.[PII_PROFILE_RESIDENTIAL_ADDRESS_FINDER_NAME],
  });

  return {
    ...state,
    state,
    setState,
    dispatch,
    setLoading,
    formProfileKYCInformation,
    setFormProfileKYCInformation,
    getFormProfileKYCPersonalDetails,
    getFormProfileKYCResidentialAddress,
  };
};

export default useProfileKYCStore;
